import { z } from 'zod';

export const ViolationTypeScalarFieldEnumSchema = z.enum(['violationtypeId','cityId','violationtag','violationname','violationcode','violationtext','violationtext2','displayGroupId','displayOrder','deleted']);

export default ViolationTypeScalarFieldEnumSchema;
